import React from 'react'
import ReservationBuilderSegmentSummary from '../ReservationBuilderSegmentSummary'
import ReservationBuilderTotal from '../ReservationBuilderTotal'
import ReservationBuilderActions from '../actions/ReservationBuilderActions'
import DataTable from '../../DataTable/DataTable'
//import I18n from "i18n-js/index.js.erb"

export default class ReservationReviewAndBookStep extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      billingPolicyExpanded: false,
    };
    this.onChange = this.onChange.bind(this);
  };

  componentDidMount() {
    var self = this;
    $(window).on("refresh_data_table", function () {
      self.refreshPricing();

      // self.setState({loading: true, dataTableRenderCount: self.state.dataTableRenderCount + 1});
    });
    // $(window).on("folioItemSaved", function () {
    //   self.refreshPricing();
    // });
  }

  render() {
    var segments = this.props.reservation.reservation_segments.map( (segment) => {
      return <ReservationBuilderSegmentSummary key={segment.temp_id || segment.id} {...this.props} reservation={this.props.reservation} segment={segment} date_format={this.props.date_format} />
    });
    if (this.props.reservation.payment_method) {
      var payment_method = this.props.reservation.payment_method;
    }

    var { reservation } = this.props;
    // set add_ons
    // for (var i = 0, ilen = reservation.reservation_segments.length; i < ilen; i++) {
    //   var reservation_segment = reservation.reservation_segments[i]
    //   var add_ons = this.getAddOnsForReservationSegment(reservation_segment);
    //   reservation_segment.add_ons = add_ons;
    // }

    return (


      <div className="confirm-finish">
        <div className="row">

          <div className="col-md-12">

            <div className="summary-of-charges">
              <h3 className="panel-heading-text">{I18n.t('summary_of_charges')}</h3>
              <div className="segments">
                {segments}
              </div>
              {/* <DataTable
               endpoint = {this.props.booking_folio_items_data_table_path}
               reservation = {reservation}
               // ids ={this.props.folio_items.map((folio_item) => {return folio_item.id})}
               no_data_text = {I18n.t('none')}
               currency_unit = {I18n.t('number.currency.format.unit')}
               delimiter = {I18n.t('number.currency.format.delimiter')}
               separator = {I18n.t('number.currency.format.separator')}
               date_format = {this.props.date_format}
               time_format = {this.props.time_format}
               read_only = {this.props.read_only} /> */}
            </div>


            <ReservationBuilderTotal reservation={this.props.reservation} bookingPaymentAmount={this.props.bookingPaymentAmount}/>
          </div>


        </div>
        <div className="row">
          <div className="col-md">
            {this.renderReservationNotes()}
          </div>
        </div>
      </div>
    );
  };

  renderReservationNotes() {
    return (
      <div className="form-group">
        <label>{I18n.t('reservation_notes')}</label>
        <textarea name="reservation.notes" defaultValue={this.props.reservation.notes} rows="3" className="form-control notes" onChange={this.onChange}></textarea>
      </div>
    );
  };

  refreshPricing() {
    ReservationBuilderActions.calculatePricing()
  }

  onChange(event) {
    if (event && event.target) {
      ReservationBuilderActions.setValue(event.target.name, event.target.value);
    };
  };

};
